// extracted by mini-css-extract-plugin
export var customCta = "resellersHero-module--customCta--62c5e";
export var hero = "resellersHero-module--hero--6fb25";